import React from "react";
import Form from "react-bootstrap/Form";
import FormField from "./FormField";
import { ValidationMessages, STATE_OPTIONS } from "Utils/Constants";

/**
 *
 * @param {SelectField.defaultProps} props
 * @returns
 */
const SelectField = (props) => {
  return <FormField {...props} />;
};

SelectField.defaultProps = {
  ...FormField.defaultProps,
  errorMessage: ValidationMessages.ADDRESS.STATE,
  options: [
    {
      value: "one",
      label: "One",
    },
    {
      value: "two",
      label: "Two",
    },
  ],
  required: true,
  renderControl: (props, showError, fieldValue, onChange, onBlur) => (
    <Form.Control
      className={showError ? "is-invalid" : ""}
      as="select"
      name="state"
      value={fieldValue}
      onChange={(e) => onChange(e.target.value)}
      onBlur={(e) => onBlur(e.target.value)}
      disabled={props.disabled}
    >
      {props.options.map((pair) => {
        return (
          <option key={pair.value} value={pair.value}>
            {pair.label}
          </option>
        );
      })}
    </Form.Control>
  ),
};

export default SelectField;
